import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { CookieService, CookieSettings } from './cookie.service';

@Component({
  selector: 'app-cookie-popup',
  templateUrl: './cookie-popup.component.html',
  styleUrls: ['./cookie-popup.component.scss'],
})
export class CookiePopupComponent implements OnInit {
  @ViewChild('cookiePopup') cookiePopupEl: ElementRef<HTMLDivElement>;

  show: boolean = false;
  showFullSettings = false;

  cookieSettings: CookieSettings;

  constructor(
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    if (isPlatformBrowser(platformId)) {
      this.cookieService.showPopup$.subscribe((show) => {
        if (show !== this.show) {
          if (show) {
            this.show = show;
            setTimeout(() => {
              this.cookiePopupEl.nativeElement.classList.add(
                'cookie-popup__show'
              );
            });
          } else {
            this.cookiePopupEl.nativeElement.classList.remove(
              'cookie-popup__show'
            );
            setTimeout(() => {
              this.show = show;
            }, 1000);
          }
        }
      });
      this.cookieSettings = this.cookieService.getCookieUserSettings();
      if (!this.cookieSettings) {
        this.cookieSettings = {
          firstParty: true,
          googleAnalytics: false, // https://www.iubenda.com/en/help/5525-cookies-gdpr-requirements#activeconsent - cannot precheck the boxes
        };
      }
    }
  }

  ngOnInit(): void {}

  acceptAll() {
    this.cookieService.acceptAll();
    this.cookieService.hidePopup();
  }

  confirmSelection() {
    this.cookieService.saveCookieUserSettings(this.cookieSettings);
    this.cookieService.hidePopup();
  }

  showSettings() {
    this.showFullSettings = true;
  }
}
